"use client"

import { t } from "@/languages/i18n"
import Image from "next/image"
import Link from "next/link"
import { FC } from "react"
import { ProductButton } from "../buttons/ProductButton"

export interface ProductItemCardProps {
  title: string
  url: string
  salePrice: string
  price: string
  category: string
  weight: string
  productUrl: string
  discountPercentage: string
}

export const ProductItemCard: FC<ProductItemCardProps> = ({
  title,
  url,
  salePrice,
  price,
  category,
  weight,
  productUrl,
  discountPercentage,
}) => {
  return (
    <div className="flex flex-col rounded-lg p-0 sm:p-5">
      <Link href={productUrl} target="_blank">
        <div className="relative flex justify-center items-center h-[148px] mb-4">
          <div className="relative flex justify-center items-center w-full h-full">
            <div className="relative max-w-[140px] max-h-[140px] w-[140px] h-[140px]">
              <Image src={url} alt={title || "product"} fill className="w-full h-full object-cover image-hover" />
            </div>
          </div>
          {parseInt(discountPercentage) > 0 && (
            <div className="absolute right-0 top-0 bg-[#f03e3e] text-white px-[0.6667rem] py-0 rounded-[2rem] text-[11px] max-h-[20px] h-full leading-[17.05px] font-bold">
              -{parseInt(discountPercentage, 10)}%
            </div>
          )}
        </div>
      </Link>

      <div className="flex flex-col flex-grow">
        <Link href={productUrl} target="_blank">
          <h3 className="font-semibold text-base leading-5 text-[#000000] hover:text-[#1EAD46] mb-2 line-clamp-2 min-h-[40px]">
            {title}
          </h3>
        </Link>
        <div className="flex justify-between items-center text-[#242F3ECC] opacity-80 text-[14px] leading-[21.7px] mb-2">
          <span className="font-normal">{category}</span>
          <span className="font-semibold">{weight}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-[#E9564F] font-bold text-sm leading-[21.7px]">{salePrice} Kč</span>
          <span className="text-[#333] text-xs leading-[18.6px] line-through opacity-90">{price} Kč</span>
        </div>
      </div>

      <ProductButton href={productUrl}>{t("Buy now")}</ProductButton>
    </div>
  )
}
